import * as React from 'react';
import {
  Paper,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Table,
} from '@nelnet/unifi-components-react';
import clsx from 'clsx';

interface IPrismicTableProps {
  table: Array<string>;
}

const PrismicTable: React.FunctionComponent<IPrismicTableProps> = ({ table }) => {
  const tableRows = table.filter((row) => typeof row === 'string' && row !== '[table]');
  const headers = tableRows[0].split(' | ');
  return (
    <Paper padding={{ x: 1 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {headers.map((header) => (
              <TableCell key={header}>{header}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableRows.map((row: string, rowIndex) => {
            const columns = row.split(' | ');

            if (rowIndex > 0) {
              return (
                <TableRow>
                  {columns.map((col, colIndex) => {
                    const colContent = colIndex === 0 ? React.createElement('code', {}, col) : col;
                    return (
                      <TableCell key={col} className={clsx(colIndex === 0 && 'table-code')}>
                        {colContent}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            }
          })}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default PrismicTable;
